module.exports = __webpack_public_path__ + "static/media/age_1.70174092.svg";